import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from '../app.constants';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HeaderService {

    constructor(
        private _router: Router,
        private _http: Http,
        private _conf:Configuration
    ) { }


    private _recentactivityUrl = this._conf.Url + 'selfActivity';
    private _searchUrl = this._conf.Url + 'generalSearch';
    // private _searchuserUrl = 'http://159.203.143.251:3000/api/v1/searchUsers';
    // private _searchhastagUrl = 'http://159.203.143.251:3000/api/v1/getHashTagSuggetion';
   

    recentactivitypeople(limit:any, offset:any) {
        var token = localStorage.getItem('authToken');
        let body = {token : token, limit:limit, offset:offset};
        
        // console.log(body);
        
        

        return this._http.post(this._conf.Url + 'selfActivity', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                // console.log('activity', res);
                
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }

    searchpeople(value:any, limit:any, offset:any) {
        var token = localStorage.getItem('authToken');
        let body = {token : token, keyToSearch:value, limit:limit, offset:offset};
        
        //console.log(body);
        
        

        return this._http.post(this._conf.Url + 'generalSearch', body, { headers: this._conf.headers })
            .map(res => res.json())
            .map((res) => {
                //console.log(res);
                
                // if (res.token) {
                //     localStorage.setItem('user', res.token);S
                //     // this._router.navigate(['Pages']);
                //     return res.code;
                // }
                return res;
            })
    }
    
    
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/header/header.service.ts
 **/